import React from "react";
import { Grid } from "@mui/material";

import { style } from "./style";

import Button from "@/components/Button";

import { IButtonVariant } from "@/models/button";

interface IProps {
  isShowIcon?: boolean;
  saveLabel?: string;
  saveHandler: () => void;
  cancelHandler: () => void;
  isLoading?: boolean;
}
const SaveCancelModalFooterActions: React.FC<IProps> = (props) => {
  const { saveLabel = "Save", cancelHandler, saveHandler, isLoading } = props;
  return (
    <Grid item sx={style.saveTemplateActionContainer}>
      <Grid item>
        <Button variant={IButtonVariant.WHITE} btnTrigger={cancelHandler}>
          Cancel
        </Button>
      </Grid>
      <Button
        isLoading={isLoading}
        btnTrigger={saveHandler}
        disabled={isLoading}
      >
        {saveLabel}
      </Button>
    </Grid>
  );
};

export default SaveCancelModalFooterActions;
